"use strict";

$(document).ready(function () {
  $('.form-popup__tabs-nav-item').click(function () {
    var parent = $(this).parents('.form-popup__tabs');
    var menu = $(parent).find('.form-popup__tabs-nav-item');
    var item = $(parent).find('.form-popup__tabs-block-item');
    var id = $(this).data('id');

    if (!$(this).hasClass('active')) {
      $(menu).removeClass('active');
      $(this).addClass('active');
      $(item).hide();
      $(parent).find('.form-popup__tabs-block-item[data-id=' + id + ']').fadeIn();
    }
  });
});